import API_BASE_URL from './config';
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

function MyPendingTitles({ playerId }) {
  const [titles, setTitles] = useState([]);
  const [titleDefinitions, setTitleDefinitions] = useState([]);
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (!playerId) return;

    const fetchTitles = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/my-pending-titles/${playerId}`, {
          headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
        });
        if (!res.ok) throw new Error('Fetch failed');
        setTitles(await res.json());
      } catch (error) {
        setMessage('Error: ' + error.message);
      }
    };

    const fetchTitleDefinitions = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/title-definitions`, {
          headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
        });
        if (!res.ok) throw new Error('Fetch failed');
        setTitleDefinitions(await res.json());
      } catch (error) {
        setMessage('Error fetching title definitions: ' + error.message);
      }
    };

    fetchTitles();
    fetchTitleDefinitions();
  }, [playerId]);

  const clearDeniedTitle = async (titleId) => {
    try {
      const res = await fetch(`${API_BASE_URL}/clear-denied-title`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify({ playerId, titleId })
      });
      if (!res.ok) throw new Error('Clear failed');
      const data = await res.json();
      setTitles(titles.filter(t => t._id !== titleId));
      setMessage(data.message);
    } catch (error) {
      setMessage('Error: ' + error.message);
    }
  };

  if (!playerId) return <p>Please log in to view titles.</p>;

  return (
    <div style={{ padding: '20px' }}>
      <h1>My Pending Titles</h1>
      {message && <p>{message}</p>}
      {titles.length > 0 ? (
        <div>
          {titles.map((title, index) => {
            const titleDef = titleDefinitions.find(td => td._id.toString() === title.titleId) || {};
            return (
              <div key={title._id} style={{ marginBottom: '20px', borderBottom: index < titles.length - 1 ? '1px solid #ccc' : 'none', paddingBottom: '10px' }}>
                <p>Dog: <Link to={`/dog/${title.dogId}`}>{title.dogId}</Link></p>
                <p>
                  Title: {titleDef.sport || 'N/A'} - {titleDef.name || 'Unknown'} ({titleDef.prefixSuffix || 'N/A'})
                </p>
                <p>Status: {title.status}</p>
                {title.artworkUrl && (
                  <p>Proof: <a href={title.artworkUrl} target="_blank" rel="noopener noreferrer">{title.artworkUrl}</a></p>
                )}
                {title.status === 'Denied' && (
                  <>
                    <p style={{ color: 'red' }}>Denied: {title.denyReason}</p>
                    <button
                      onClick={() => clearDeniedTitle(title._id)}
                      style={{ background: '#ff4d4d', color: 'white', padding: '5px 10px', border: 'none', borderRadius: '5px', cursor: 'pointer' }}
                    >
                      Clear Notice
                    </button>
                  </>
                )}
              </div>
            );
          })}
        </div>
      ) : (
        <p>No pending or denied titles.</p>
      )}
    </div>
  );
}

export default MyPendingTitles;